<div class="flex-container">

<div mat-dialog-content class="paragrafo">
  Deseja enviar notificações para as pessas sobre {{data.text}}?
</div>
<div mat-dialog-actions class="flex-btn">
  <button mat-raised-button class="btn-salvar" [mat-dialog-close]="onYes()"> Enviar</button>
  <button mat-raised-button [mat-dialog-close]="onNoClick()" class="btn-clear">Não Enviar</button>
</div>
</div>
